import Layout4Login from "components/layout/Layout4Login";
import Css from './Login.module.css';
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { useState } from "react";

export default function ResetPassword() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const api = new ApiConection();
    const [validated, setValidated] = useState(false);
    const [input, setInput] = useState({
        password: '',
        confirm_password:''
    });
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        const { name, type, value } = event.target;

        setInput(prevData => {
            return { ...prevData, [name]: value }
        })
    }

    const handleReset = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        //console.log(searchParams.get('id'))
        const id = searchParams.get('id');

        let data = {
            request_id: encodeURIComponent(id),
            password: input.password,
            confirm_password: input.confirm_password
        }

        

        const response = await api.callLandingPagePostV2('api/Authentication/reset-password/admin', data);
        setLoading(false);

        if (response.status === false) {
            setAlert(response.message);
        } else {
            navigate('/reset/confirm');
        }
    }

    const handleLogin = (event) => {
        navigate(process.env.PUBLIC_URL + '/login');
    }

    return (
        <Layout4Login>
             <div className={Css.Login_outer_layout1}>
                <div className={Css.admin}>
                    <div className='d-flex flex-row'>
                        <div className=''>
                            <img src={require("images/mst.jpg")} className={Css.imgsize} />
                        </div>
                        <div className='p-5 m-2'>
                            <Form noValidate validated={validated} onSubmit={handleReset} style={{width:'330px'}}>
                                <img src={require("images/DCasS.png")} height={69} />
                                <h3 className={`mt-2`}>รีเซ็ตรหัสผ่าน</h3>
                                <label>โปรแกรมระบบควบคุมเอกสารอิเล็กทรอนิกส์</label>
                                <Form.Group as={Row} className="text-start mb-2  mt-5">
                                    <Form.Label >รหัสผ่าน (ไม่น้อยกว่า 8 ตัวอักษร)</Form.Label>
                                    <Col>
                                        <Form.Control type={'password'} pattern="(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*]).{8,}" name={'password'} value={input.password} onChange={handleChange} required={true} />
                                        <Form.Control.Feedback type={'invalid'}>
                                            1 ตัวอักษรภาษาอังกฤษพิมพ์เล็ก และ 1 ตัวอักษรภาษาอังกฤษพิมพ์ใหญ่.<br />
                                            1 ตัวเลข (0-9).<br />
                                            1 อัขระพิเศษดังนี้ (!@#$%^&*).<br />
                                            ความยาวรวมกันอย่างน้อย 8 ตัวอักษร.<br />
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="text-start mb-2">
                                    <Form.Label >ยืนยันรหัสผ่าน (รหัสผ่านต้องเหมือนกัน)</Form.Label>
                                    <Col>
                                        <Form.Control type={'password'} pattern="(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*]).{8,}" name={'confirm_password'} value={input.confirm_password} onChange={handleChange} required={true} />
                                    </Col>
                                </Form.Group>
                             
                                {
                                    alert !== '' &&
                                    <div className="alert alert-danger" role="alert">
                                        <div className="text-end">
                                            <button type="button" className="btn-close" onClick={(event) => setAlert('')}></button>
                                        </div>

                                        {alert}
                                    </div>
                                }
                                <div className={`mt-4`}>
                                    <Button type={'submit'} className={`${Css.loginbtn} w-100 mt-3`} >
                                        {
                                            loading === true &&
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        }
                                        ยืนยัน
                                    </Button>
                                </div>
                                <Form.Group className="text-end mt-3 mb-2">
                                    <a className={`${Css.font1} ${Css.Alink_black}`} onClick={handleLogin}>คลิกเข้าสู่ระบบ?</a>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            
        </Layout4Login>
    );
}